// extracted by mini-css-extract-plugin
export default {"backdropChevron":"VMMahsJF","rotatedTriangle":"LCLPELoN","triangle":"Hbfsc0kz"};